import { render, staticRenderFns } from "./ImageButton.vue?vue&type=template&id=5d1852f7&scoped=true&"
import script from "./ImageButton.vue?vue&type=script&lang=js&"
export * from "./ImageButton.vue?vue&type=script&lang=js&"
import style0 from "./ImageButton.vue?vue&type=style&index=0&id=5d1852f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1852f7",
  null
  
)

export default component.exports